import React from 'react'
import useEmblaCarousel from 'embla-carousel-react'

const FilterButtons = ({ categorys, filter, setFilter }) => {
  const [viewportRef] = useEmblaCarousel({
    containScroll: "keepSnaps",
    align: 'start',
    dragFree: false
  })

  return (
    <>
      <div className="Cardfilters embla">
        <div className="embla__viewport" ref={viewportRef}>
          <div className="embla__container">
            <button
              className={`nav-link ${filter === 'Todos' && 'active'}`}
              onClick={() => setFilter('Todos')}
            >
              Todos
            </button>
            
            {categorys.map((cat, id) => {
              return (
                <button
                  className={`nav-link ${filter === cat && 'active'}`}
                  onClick={() => setFilter(cat)}
                  key={`btn-filter-${id}`}
                >
                  {cat}
                </button>
              )
            })} 
          </div>
        </div>
      </div>
    </>
  )
}

export default FilterButtons
